import { formatDateHHMM } from "../../../../../../../../utils/date";
import { useWalletLogContext } from "../../../../../hooks/wallet-log-context";
import { checkSubPrizeLogType } from "../../../utils/log-type";
import {
  SubPrizeRewardLogAppResponse,
  SubPrizeRewardLogType,
} from "../../../../../../../../api/sub-prize";
import {
  WalletLogsListRow,
  WalletLogListDate,
  WalletLogsListItemWrapper,
  WalletLogsListItem,
  WalletLogsListItemInfo,
  WalletLogsRowBorder,
} from "../style";

interface GroupedSubPrizeLog {
  date: string;
  list: SubPrizeRewardLogAppResponse[];
}

const WalletLogsSubPrizeList = () => {
  const { subPrizeLogs } = useWalletLogContext();

  const formatDate = (value: string) => {
    const [, month, day] = value.split("-");
    return `${month}.${day}`;
  };

  // 날짜별로 그룹화하는 함수
  const groupLogsByDate = (
    logs: SubPrizeRewardLogAppResponse[]
  ): GroupedSubPrizeLog[] => {
    const grouped = logs.reduce((acc, log) => {
      const date = new Date(log.createdAt).toISOString().split("T")[0];
      if (!acc[date]) {
        acc[date] = [];
      }
      acc[date].push(log);
      return acc;
    }, {} as Record<string, SubPrizeRewardLogAppResponse[]>);

    return Object.entries(grouped)
      .map(([date, list]) => ({ date, list }))
      .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
  };

  // 실제 데이터만 사용
  const rawLogs = subPrizeLogs;
  const groupedLogs = groupLogsByDate(rawLogs);

  return (
    <>
      {groupedLogs.map((item, index) => (
        <div key={index}>
          <WalletLogsListRow>
            <WalletLogListDate>{formatDate(item.date)}</WalletLogListDate>
            <WalletLogsListItemWrapper>
              {item.list.map((log, i) => (
                <WalletLogsListItem key={i}>
                  <WalletLogsListItemInfo>
                    <div className="info">
                      {log.pubName}{" "}
                      {checkSubPrizeLogType(log.type) ? "지급" : "차감"}
                    </div>
                    <div className="date">
                      {formatDateHHMM(log.createdAt.toString())}
                    </div>
                  </WalletLogsListItemInfo>
                  <div className="point">
                    {checkSubPrizeLogType(log.type) ? "+" : "-"}
                    {log.count?.toLocaleString()} {log.name}
                  </div>
                </WalletLogsListItem>
              ))}
            </WalletLogsListItemWrapper>
          </WalletLogsListRow>
          <WalletLogsRowBorder />
        </div>
      ))}
    </>
  );
};

export default WalletLogsSubPrizeList;
